"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
export default function Contact() {
  return;
}
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-green-900/30 border border-green-500/50 rounded-lg text-center">
        <p className="text-green-400 mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="bg-transparent text-white border-white/20 hover:bg-white/10">
          Ուղարկել նոր հարցում
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <FormField control={control} name="name" rules={{
      required: "Անունը պարտադիր է"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-gray-300 text-xs uppercase tracking-wider">Ազգանուն Անուն*</FormLabel>
            <FormControl>
              <Input placeholder="" {...field} className="bg-[#333333] border-none text-white focus-visible:ring-1 focus-visible:ring-white/30 h-11" />
            </FormControl>
            <FormMessage className="text-red-400 text-xs" />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Էլ. հասցեն պարտադիր է",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Սխալ էլ. հասցե"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-gray-300 text-xs uppercase tracking-wider">Էլ. Հասցե*</FormLabel>
            <FormControl>
              <Input type="email" placeholder="" {...field} className="bg-[#333333] border-none text-white focus-visible:ring-1 focus-visible:ring-white/30 h-11" />
            </FormControl>
            <FormMessage className="text-red-400 text-xs" />
          </FormItem>} />

      <FormField control={control} name="phone" rules={{
      required: "Հեռախոսահամարը պարտադիր է"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-gray-300 text-xs uppercase tracking-wider">Հեռ. Համար*</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="" {...field} className="bg-[#333333] border-none text-white focus-visible:ring-1 focus-visible:ring-white/30 h-11" />
            </FormControl>
            <FormMessage className="text-red-400 text-xs" />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Հաղորդագրությունը պարտադիր է"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-gray-300 text-xs uppercase tracking-wider">Ինչպե՞ս կարող ենք օգնել Ձեզ*</FormLabel>
            <FormControl>
              <Textarea placeholder="" {...field} className="bg-[#333333] border-none text-white min-h-[120px] focus-visible:ring-1 focus-visible:ring-white/30 resize-none" />
            </FormControl>
            <FormMessage className="text-red-400 text-xs" />
          </FormItem>} />

      {submitError && <div className="p-3 bg-red-900/30 border border-red-500/50 rounded-md">
          <p className="text-red-400 text-sm">{submitError}</p>
        </div>}

      <div className="pt-4 flex justify-center">
        <Button type="submit" disabled={isSubmitting} className="bg-transparent hover:bg-white/5 text-gray-400 hover:text-white border border-gray-700 hover:border-gray-500 px-8 py-6 rounded-md transition-colors w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Ուղարկվում է...
            </> : "Ուղարկել Դիմումը"}
        </Button>
      </div>
    </Form>;
}